import * as _ from 'lodash';
import { fromJS } from 'immutable';

import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import * as searchActions from '../actions/search';
import * as actions from '../actions/event';
import { fetchingState } from '@constants';

const initialState = {
  eventFormList: { state: null, data: [] },
  searchOptions: { state: null, data: {} },
  searchLastData: { data: {}, state: null },
  formTags: { state: null, data: [] },
  eventList: {
    state: null,
    data: [],
    formID: null,
    searchOptions: { state: null, data: {} },
    searchParams: {},
    sortModel: [],
    filterModel: {},
  },
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 10000,
    rowsPerPageOptions: [10000, 5000, 1000],
  },
  searchStat: { state: null, data: [] },
  searchParams: {
    data: [],
    state: null,
  },
  searchParam: {
    data: {},
    state: null,
  },
  criteria: {},
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case searchActions.EVENT_FORMS_FETCH_START: {
      return state.setIn(['eventFormList', 'state'], fetchingState.FETCHING);
    }
    case searchActions.EVENT_FORMS_FETCH_SUCCESS: {
      return state
        .setIn(['eventFormList', 'state'], fetchingState.LOADED)
        .setIn(
          ['eventFormList', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case searchActions.EVENT_FORMS_FETCH_ERROR: {
      return state.setIn(['eventFormList', 'state'], fetchingState.ERROR);
    }

    case searchActions.SEARCH_OPTIONS_FETCH_START: {
      return state.setIn(['searchOptions', 'state'], fetchingState.FETCHING);
    }
    case searchActions.SEARCH_OPTIONS_FETCH_SUCCESS: {
      return state
        .setIn(['searchOptions', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchOptions', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case searchActions.SEARCH_OPTIONS_FETCH_ERROR: {
      return state.setIn(['searchOptions', 'state'], fetchingState.ERROR);
    }
    case searchActions.CLEAR_SEARCH_OPTIONS: {
      return state.setIn(['searchOptions'], fromJS(initialState.searchOptions));
    }

    case searchActions.EVENTS_FETCH_START: {
      return (!action.initial
        ? state.setIn(['eventList', 'state'], fetchingState.FETCHING)
        : state
            .setIn(['eventList', 'state'], fetchingState.FETCHING)
            .setIn(['eventList', 'searchOptions'], state.get('searchOptions'))
            .setIn(
              ['eventList', 'searchParams'],
              fromJS(_.get(action, 'payload', {})),
            )
      )
        .setIn(['pagination', 'page'], action.page)
        .setIn(['pagination', 'rowsPerPage'], action.pageSize)
        .setIn(['searchLastData', 'data'], fromJS(action));
    }
    case searchActions.EVENTS_FETCH_SUCCESS: {
      return state
        .setIn(['eventList', 'state'], fetchingState.LOADED)
        .setIn(['eventList', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(['eventList', 'formID'], action.data ? action.data.formID : null)
        .setIn(
          ['pagination', 'count'],
          _.get(action, 'data.totalEvents.eventCount', 0),
        )
        .setIn(['searchStat', 'state'], null)
        .setIn(['searchStat', 'data'], fromJS([]));
    }
    case searchActions.EVENTS_FETCH_ERROR: {
      return state.setIn(['eventList', 'state'], fetchingState.ERROR);
    }

    case searchActions.SEARCH_STAT_FETCH_START: {
      return state.setIn(['searchStat', 'state'], fetchingState.FETCHING);
    }
    case searchActions.SEARCH_STAT_FETCH_SUCCESS: {
      return state
        .setIn(['searchStat', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchStat', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case searchActions.SEARCH_STAT_FETCH_ERROR: {
      return state.setIn(['searchStat', 'state'], fetchingState.ERROR);
    }

    case searchActions.FORM_TAGS_FETCH_START: {
      return state.setIn(['formTags', 'state'], fetchingState.FETCHING);
    }
    case searchActions.FORM_TAGS_FETCH_SUCCESS: {
      return state
        .setIn(['formTags', 'state'], fetchingState.LOADED)
        .setIn(['formTags', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case searchActions.FORM_TAGS_FETCH_ERROR: {
      return state.setIn(['formTags', 'state'], fetchingState.ERROR);
    }

    case actions.EVENT_DELETE_SUCCESS: {
      return state.setIn(
        ['eventList', 'data'],
        fromJS(
          state
            .getIn(['eventList', 'data'])
            .toJS()
            .filter(
              ev =>
                parseInt(ev.eventID, 10) !== parseInt(action.data.eventID, 10),
            ),
        ),
      );
    }

    case searchActions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case searchActions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }
    case searchActions.CHANGE_SORT_MODEL: {
      return state.setIn(['eventList', 'sortModel'], fromJS(action.payload));
    }
    case searchActions.CHANGE_FILTER_MODEL: {
      return state.setIn(['eventList', 'filterModel'], fromJS(action.payload));
    }

    case searchActions.CLEAR_EVENTS: {
      return state
        .setIn(['eventList'], fromJS(initialState.eventList))
        .setIn(['pagination'], fromJS(initialState.pagination))
        .setIn(['searchStat'], fromJS(initialState.searchStat));
    }

    case searchActions.EVENTS_SEARCH_PARAMS_FETCH[START]: {
      return state.setIn(['searchParams', 'state'], fetchingState.FETCHING);
    }
    case searchActions.EVENTS_SEARCH_PARAMS_FETCH[SUCCESS]: {
      return state
        .setIn(['searchParams', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParams', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case searchActions.EVENTS_SEARCH_PARAMS_FETCH[ERROR]: {
      return state.setIn(['searchParams', 'state'], fetchingState.ERROR);
    }

    case searchActions.EVENTS_SEARCH_PARAM_INSERT[SUCCESS]:
    case searchActions.EVENTS_SEARCH_PARAM_UPDATE[SUCCESS]: {
      return state
        .setIn(['searchParam', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParam', 'data'],
          fromJS(_.get(action, 'data.results.0', {})),
        );
    }

    case searchActions.EVENTS_SEARCH_PARAM_SET: {
      return state.setIn(
        ['searchParam', 'data'],
        fromJS(
          state
            .getIn(['searchParams', 'data'])
            .toJS()
            .find(v => v.searchParamID === action.searchParamID),
        ),
      );
    }

    case searchActions.EVENTS_SEARCH_PARAM_RESET: {
      return state.setIn(['searchParam', 'data'], fromJS({}));
    }

    case searchActions.SET_CRITERIA: {
      return state.setIn(['criteria'], fromJS(action.payload));
    }

    default: {
      return state;
    }
  }
};
